import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface ComiteTipoActa {
  id?: number;
  descripcion: string;
  estado?: number;
  fechaCreacion?: Date;
  fechaModificacion?: Date;
}

export interface ComiteTipoActaResponse {
  data: ComiteTipoActa[];
}

export interface ComiteTipoActaSingleResponse {
  message?: string;
  data: ComiteTipoActa;
}

@Injectable({
  providedIn: 'root'
})
export class ComiteTipoActaService {
  private apiUrl = `${environment.apiUrl}/api/comite-tipo-acta`;

  constructor(private http: HttpClient) {}

  /**
   * Obtener todos los tipos de acta
   */
  getAll(): Observable<ComiteTipoActaResponse> {
    return this.http.get<ComiteTipoActaResponse>(this.apiUrl);
  }

  /**
   * Obtener tipos de acta activos
   */
  getActivos(): Observable<ComiteTipoActaResponse> {
    return this.http.get<ComiteTipoActaResponse>(`${this.apiUrl}/activos`);
  }

  /**
   * Obtener un tipo de acta por ID
   */
  getById(id: number): Observable<ComiteTipoActa> {
    return this.http.get<ComiteTipoActa>(`${this.apiUrl}/${id}`);
  }

  /**
   * Crear un nuevo tipo de acta
   */
  create(tipoActa: ComiteTipoActa): Observable<ComiteTipoActaSingleResponse> {
    return this.http.post<ComiteTipoActaSingleResponse>(this.apiUrl, tipoActa);
  }

  /**
   * Actualizar un tipo de acta existente
   */
  update(id: number, tipoActa: Partial<ComiteTipoActa>): Observable<ComiteTipoActaSingleResponse> {
    return this.http.put<ComiteTipoActaSingleResponse>(`${this.apiUrl}/${id}`, tipoActa);
  }

  /**
   * Inactivar un tipo de acta (borrado lógico)
   */
  remove(id: number): Observable<ComiteTipoActaSingleResponse> {
    return this.http.delete<ComiteTipoActaSingleResponse>(`${this.apiUrl}/${id}`);
  }

  /**
   * Activar un tipo de acta
   */
  activate(id: number): Observable<ComiteTipoActaSingleResponse> {
    return this.http.patch<ComiteTipoActaSingleResponse>(`${this.apiUrl}/${id}/activate`, {});
  }
}
